import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
}

export const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    setStatus: (state, action) => {
      state.isLoading = action.payload.isLoading
    },
  }
})

export const {setStatus} = loaderSlice.actions

export default loaderSlice.reducer